export default {
  settingKey: '底部邮箱',
  setting: {
    是否展示: {
      type: 'boolean',
      default: true
    },
    邮箱文案: {
      type: 'string',
      default: 'VIP福利合作邮箱请联系: winstonyin@tencent.com'
    }
  },
  computed: {
    serverSetting: function serverSetting() {
      if (this.$store.state.indexPageModule.serverSetting && this.$store.state.indexPageModule.serverSetting['底部邮箱']) {
        return this.$store.state.indexPageModule.serverSetting['底部邮箱'];
      }
      return null;
    }
  }
};